export default {
  path: '/wecode/doc',
  auth: false,
  preload: false,
  isStatic: true,
  key: 'doc',
  component: () => import('./index')
};
